// Used for both Post and Comment

export const postReactions = ['like', 'love', 'haha', 'sad', 'angry'] as const

export type ReactionType = typeof postReactions[number]

export type Reaction = {
  name: ReactionType
  label: string
  color: string
  icon: string
  count: number
  userId: string
}
